import React, { useEffect, useMemo, useState, useCallback } from 'react';
import { Row, Col } from 'react-bootstrap';
import { Card, Button, Text, Fallback } from 'v3/components';
import theme from 'v3/theme';
import { useModal } from 'hooks';
import { useTravel } from '../..';
import * as svc from './Services';
import * as S from './styles';
import AdjustmentsModal from './Modal';

const GROUP_LABELS = {
  NEGOTIATION: 'Negociação',
  OPERATION: 'Operação',
  GRO: 'GRO',
  REGISTRATION: 'Cadastro',
  RISK_MANAGER: 'GR',
  REGISTER: 'Cadastro',
  NEGOTIATOR_CUSTOMER: 'Negociador (Cliente)',
};

export default function PendingTravelCard() {
  const travel = useTravel();
  const modal = useModal();
  const travelId = travel?.data?.id;
  const [loading, setLoading] = useState(false);
  const [groups, setGroups] = useState([]);
  const [totals, setTotals] = useState({});
  const COLOR_PENDING = S.colors?.pending || '#fb8c00';
  const COLOR_FINISHED = S.colors?.finished || '#2e7d32';
  const COLOR_CANCELED = S.colors?.danger || '#c62828';
  const fetchBase = useCallback(async () => {
    if (!travelId) return;
    setLoading(true);
    try {
      const [groupsRes, totalsRes] = await Promise.all([
        svc.getGroups(),
        svc.getTotals(travelId),
      ]);

      const parsedGroups = (groupsRes?.data || []).map((g) => ({
        slug: g.slug,
        name: GROUP_LABELS[g.slug] || g.name || g.slug,
      }));

      const totalsObj = totalsRes?.data || {};
      const parsedTotals = {};

      Object.entries(totalsObj).forEach(([key, value]) => {
        const slug = String(key).toUpperCase();
        parsedTotals[slug] = {
          total: Number(value?.total) || 0,
          pending: Number(value?.pending) || 0,
          finished: Number(value?.finished) || 0,
        };
      });

      setGroups(parsedGroups);
      setTotals(parsedTotals);
    } catch (err) {
      console.error('Erro ao carregar pendências:', err);
    } finally {
      setLoading(false);
    }
  }, [travelId]);

  useEffect(() => {
    fetchBase();
  }, [fetchBase]);

  const list = useMemo(() => {
    return groups.map((g) => {
      const gTotals =
        totals[g.slug?.toUpperCase?.() ? g.slug.toUpperCase() : g.slug] || {
          total: 0,
          pending: 0,
          finished: 0,
        };

      const canceled = Math.max(
        0,
        (gTotals.total || 0) - ((gTotals.pending || 0) + (gTotals.finished || 0))
      );

      return {
        slug: g.slug,
        label: g.name,
        total: gTotals.total ?? 0,
        pending: gTotals.pending ?? 0,
        finished: gTotals.finished ?? 0,
        canceled,
      };
    });
  }, [groups, totals]);
  return (
    <>
      <Card
        loading={travel.isLoading || loading}
        header={<Text color="dark" type="header">Pendência da viagem</Text>}
        HeaderRightComponent={
          <Button onClick={modal.open}>
            <Text color="white">Visualizar</Text>
          </Button>
        }
      >
        <Fallback
          fall={!list?.length}
          component={
            <Col className="pt-2 d-flex justify-content-center align-items-center">
              <Button colors={theme.colors.primary} size="md" disabled>
                Não há itens a serem exibidos
              </Button>
            </Col>
          }
        >
          <div style={{ paddingTop: 6 }}>
            {list.map((item) => (
              <Row key={item.slug} className="g-0">
                <Col xs={12}>
                  <div style={S.rowCard}>
                    <div style={S.rowLeft}>
                      <span style={S.groupTitle}>{item.label}</span>
                    </div>
                    <div style={S.rowRight}>
                      <div style={S.metric}>
                        <div style={S.metricValue}>{item.total}</div>
                        <div style={S.metricLabel}>Total</div>
                      </div>
                      <div style={S.metric}>
                        <div style={{ ...S.metricValue, color: COLOR_PENDING }}>
                          {item.pending}
                        </div>
                        <div style={S.metricLabel}>Pendente</div>
                      </div>
                      <div style={S.metric}>
                        <div style={{ ...S.metricValue, color: COLOR_CANCELED }}>
                          {item.canceled}
                        </div>
                        <div style={S.metricLabel}>Anulado</div>
                      </div>
                      <div style={S.metric}>
                        <div style={{ ...S.metricValue, color: COLOR_FINISHED }}>
                          {item.finished}
                        </div>
                        <div style={S.metricLabel}>Finalizado</div>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            ))}
          </div>
        </Fallback>
      </Card>
      <AdjustmentsModal
        isOpen={modal.isOpen}
        onClose={() => {
          modal.close();
          fetchBase();
        }}
        travelId={travelId}
      />
    </>
  );
}
